import { render, staticRenderFns } from "./InventarioForm.vue?vue&type=template&id=5a84402e&scoped=true"
import script from "./InventarioForm.vue?vue&type=script&lang=js"
export * from "./InventarioForm.vue?vue&type=script&lang=js"
import style0 from "./InventarioForm.vue?vue&type=style&index=0&id=5a84402e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84402e",
  null
  
)

export default component.exports